var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('hiv-quiz',{attrs:{"question":"If you take PrEP, it’s OK to stop using condoms during sex to prevent HIV infection.","answer":false}})}
var staticRenderFns = []

export { render, staticRenderFns }